import {TimelineMax, TweenLite} from 'gsap';
const Shortcuts = require('../utils/Shortcuts');

const win = window;

function TextSliderTimeline(selector, refDuration) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;

        // TweenLite.set(selector, {opacity: 1});

        const obj = {progress: 0, on: false, element: document.querySelector(selector), container: document.querySelector(selector + ' .js--container')};
        constructor.obj = obj;
        constructor.update = () => {
            const obj = constructor.obj;
            obj.container.style.transform = `translate3d(0, ${-obj.deltaH * obj.progress}px, 0)`;

        };
        constructor.initParams = () => {
            const obj = constructor.obj;
            obj.deltaH = Math.max(0, obj.container.getBoundingClientRect().height - obj.element.getBoundingClientRect().height);
        };
        constructor.resize = () => {
            if (constructor.timeout) { clearTimeout(constructor.timeout); delete constructor.timeout; }
            constructor.timeout = setTimeout(() => {
                constructor.initParams();
                constructor.update();
            }, 50);
        };
        const tl = new TimelineMax({
            paused: true,
            onUpdate: constructor.update
        });

        tl.set(obj, {progress: 0}, 'st');
        tl.to(obj, refDuration, {progress: 1}, 'st');

        constructor.initParams();
        win.addEventListener('resize', constructor.resize);

        constructor.timeline = tl;
        _created = true;
        return tl;
    };

    constructor.destroy = () => {
        if (!_created) return;
        if (constructor.timeout) { clearTimeout(constructor.timeout); delete constructor.timeout; }
        Shortcuts.destroyTimeline(constructor);
        win.removeEventListener('resize', constructor.resize);
        TweenLite.set(selector, {opacity: 0});
        _created = false;
    };

    constructor.totalDuration = refDuration;

    return constructor;
}

module.exports = TextSliderTimeline;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/texts/TextSliderTimeline.js